<template>
  <div class="reports-add-jobs reports-add-jobs-workorder" v-show="!isLoad">
    <el-dialog
      :visible.sync="dialogObject"
      @close="backHandler"
      title="Отчет по работе"
      custom-class="add-jobs-dialog-workorder">
      <div class="back-button-left" @click="backToReport"><i class="fa fa-chevron-left"></i></div>
      <div class="plus-header-button">
        <div class="plus-button" @click="createCustom()">+</div>
        <i class="el-icon-set-up" @click="fetchJobs(true)"></i>
      </div>
      <div v-if="isCreateJob" class="jobs-create-container">
        <JobsCreate
          :type_prop="'JOB'"
          :obj="obj && obj.id"
          @close="isCreateJob = false"
          @created="isObject ? createCustom() : fetchJobs()"
          isNested
        />
      </div>
      <div class="add-jobs" v-else-if="!form.job" v-loading="fetchLoader">
        <div style="display: flex !important; padding-left: 32px !important; position: sticky !important; top: 54px !important; justify-content: flex-start !important; flex: 1 !important; background: #fff !important; padding-bottom: 1px !important; z-index: 999;">
          <div>
            <el-switch v-model="isNotWork">
            </el-switch>
            <strong>Не выполнено</strong>
          </div>
        </div>
        <!--        <el-input clearable placeholder="Поиск ..." v-model="search" class="input-search">-->
        <!--          <el-button slot="append" icon="el-icon-search"></el-button>-->
        <!--        </el-input>-->
        <div style="display:flex; align-items: center;" class="input-search"
        >
          <el-checkbox

            @change="checkboxSelect"
            style="margin-right: 12px; margin-left: 10px"
            v-model="selectAll"
          ></el-checkbox>
          <el-input placeholder="Поиск по работам ..." v-model="search" clearable :class="['input-search']">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <div class="jobs-ul">
          <div
            v-show="!!isShow(job)"
            class="jobs-li" style="justify-content: flex-start; flex-wrap: nowrap; width: 100%"
            v-if="!(obj && obj.id === null)"
            v-for="(job, index) in jobs"
            :key="(job && job.id) + '' + index"

          >
            <el-checkbox v-model="jobs[index].isSelect" style="margin-right: 8px"></el-checkbox>
            <div @click="selectJob(job)" style="display: flex; flex-direction: column; width: 100%"
                 :style="{opacity: job.unit_for_value > 0 ? 1: 0.7}">
              <div style="display: flex; justify-content: space-between; width: 100%">
                <span>{{ job.name }}</span>
                <strong style="margin-right: 8px; margin-left: 4px;     white-space: nowrap;"
                        v-if="job.type === 'JOB' && Number(job.plan)"
                        :style="{color: pStatus(findPercentage(job.totalValue || 0, job.plan))}">
                  {{ findPercentage(job.totalValue || 0, job.plan) }}%
                </strong>
              </div>


              <div style="margin-top: 4px">
                <strong style="margin-right: 8px">П: <strong>{{
                    toFixedWithoutZero(job.plan || 0)
                  }}</strong></strong>
                <strong style="margin-right: 8px">Ф: <strong>{{
                    toFixedWithoutZero(job.totalValue || 0)
                  }}</strong></strong>
                <strong style="margin-right: 8px">+\-: <strong>{{
                    (toFixedWithoutZero((job.totalValue || 0) - (job.plan || 0)))
                  }}</strong></strong>

                <strong v-if="$store.state.project.daily_plan" style="margin-right: 8px">ПС: <strong>{{
                    (toFixedWithoutZero((job.volumes && job.volumes.length) ? job.volumes[mainForm.turn.value - 1][datetime] : '...'))
                  }}</strong></strong>
              </div>
            </div>
          </div>
          <div class="jobs-li link" @click="createCustom">
            <span>
                  + Добавить произвольную работу
              </span>
          </div>
          <div class="jobs-li link" v-if="role === 'admin' && !(obj && obj.id === null)" @click="createJob">
            <span>
              + Создать работу в плане
            </span>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="backToReport">Назад</el-button>
          <el-button type="primary" @click="() => saveToReport()">Добавить в отчет</el-button>
        </span>
      </div>
      <template v-else>
        <div v-loading="loader" style="margin-top: 12px">
          <div>
            <AddJobs :report="report" :approve="approve" :isEditable="isEditable" :job="insertJob" @save="saveCopy"
                     ref="addJobsInsert"/>

            <div>
              <div @click="copyJobOpen = true" style="margin-bottom: 8px; display: flex; align-items: center">
              <span><strong>{{ form.job.name || form.name }}</strong>{{
                  form.job.unit ? `, ${(form.job.unit && form.job.unit.label || form.job.unit)}` : ''
                }}
              </span>
                <i v-if="editIndex === 'create'" style="display: flex; margin-left: 8px"
                   class="el-icon-document-copy" @click="copyJobOpen = true"></i>
              </div>

              <div class="select-value" v-if="isCreateCustom" style="width: 100%; margin-bottom: 8px">
                <el-row>
                  <el-col :span="18">
                    <el-form-item>
                      <!--                      <el-input style="margin-right: 8px" v-model="form.job.name" placeholder="Найменование работы">-->
                      <!--                      </el-input>-->
                      <el-autocomplete
                        v-model="form.job.name"
                        :fetch-suggestions="querySearch"
                        placeholder="Найменование работы"
                        style="margin-right: 8px; width: 100%"
                        :trigger-on-focus="false"
                        @select="handleSelectOption"
                      >
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item>
                      <el-input style="margin-left: 8px" v-model="form.job.unit" placeholder="Ед. изм."/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div v-if="$store.state.project.daily_plan || $store.state.project.plan">
                <el-row>
                  <el-col :span="12">
                    <el-input v-if="!$store.state.project.plan"
                              style="margin-right: 8px"
                              type="number"

                              placeholder="Сменный план"
                              v-model="form.daily_plan" class="input-with-select">
                    </el-input>
                    <el-input
                      v-else
                      style="margin-right: 8px"
                      type="number"

                      placeholder="Сменный план"
                      v-model="form.daily_plan"
                      class="input-with-select"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-input
                      style="margin-left: 8px"
                      :disabled="approve"
                      type="number"

                      placeholder="Сменный факт"
                      @input="valueMaterials"
                      v-model="form.value" class="input-with-select">
                    </el-input>
                  </el-col>
                </el-row>
              </div>


              <el-input type="number"
                        v-else :class="{'disable-report':  approve}" :placeholder="'Значение'"
                        v-model="form.value" class="input-with-select">
              </el-input>

              <el-input :class="{'disable-report':  approve}" v-model="form.job.comment"
                        style="margin-top: 8px; margin-bottom: 8px" placeholder="Комментарий"
                        type="textarea" textarea/>

              <div class="add-jobs-values" v-if="!isCreateCustom">
                <span style="margin-right: 8px">П: <strong>{{
                    toFixedWithoutZero(calcPlan || this.form.job.plan)
                  }}</strong></span>
                <span style="margin-right: 8px">Ф: <strong>{{
                    toFixedWithoutZero(form.job.totalValue)
                  }}</strong></span>
                <span style="margin-right: 8px">+\-: <strong>{{
                    toFixedWithoutZero(form.job.totalValue - (calcPlan || this.form.job.plan))
                  }}</strong></span>
                <strong v-if="Number(calcPlan)"
                        :style="{color: pStatus(findPercentage(calcValue, calcPlan))}">
                  {{ findPercentage(calcValue, calcPlan) }}%
                </strong>
              </div>
            </div>
          </div>
          <div class="add-jobs" style="margin-bottom: 8px" :class="{'disable-report':  approve}" v-show="!loader">
            <div style="margin-top: 6px">
              <div v-for="input in form.job.inputs || []" v-show="input.show !== false">
                <div v-if="input.type === 'text'"
                     style="margin-top: 10px; display: flex; flex-direction: column; align-items: flex-start">
                  <strong style="color: black">{{ input.name }}
                  </strong>
                  <el-input
                    style="margin-top: 4px"
                    :placeholder="input.name"
                    v-model="input.value"
                    class="input-with-select"
                  >
                  </el-input>
                </div>
                <div v-if="input.type === 'number'"
                     style="margin-top: 10px; display: flex; flex-direction: column; align-items: flex-start">
                  <strong style="color: black">{{ input.name }}
                  </strong>
                  <el-input
                    :controls="false"
                    style="margin-top: 4px"
                    type="number"
                    :placeholder="input.name"
                    v-model="input.value"
                    class="input-with-select"
                  />
                </div>
                <div v-if="input.type === 'date'"
                     style="margin-top: 10px; display: flex; flex-direction: column; align-items: flex-start">
                  <strong style="color: black; margin-bottom: 8px">{{ input.name }}
                  </strong>
                  <el-date-picker
                    format="yyyy-MM-dd"
                    v-model="input.value"
                    type="date"
                    placeholder="Укажите дату"
                  >
                  </el-date-picker>
                </div>
                <div v-if="input.type === 'calc'"
                     style="margin-top: 10px; display: flex; flex-direction: column; align-items: flex-start">
                  <strong style="color: black; margin-bottom: 8px">{{ input.name }}</strong>

                  <el-input
                    :controls="false"
                    style="margin-top: 4px; max-width: 220px; pointer-events: none"
                    type="number"
                    :placeholder="input.name"
                    :value="getCalc(input)"
                    class="input-with-select"
                  />
                </div>

                <div
                  v-if="input.type.includes('materials') || input.type.includes('constructions') || input.type.includes('multiple')">
                  <div class="material-title" style="margin-bottom: 8px; margin-top: 10px">
                    <strong style="color: black;">{{ input.name }}
                    </strong>
                    <span
                      v-if="showCalc(input.volumeId) && input.type.includes('multiple')"
                      @click="toFactMultiple(input)"
                      class="sum-icon" style="margin-left: 4px">&sum;</span>
                    <span
                      v-else
                      @click="toFact(input)"
                      class="sum-icon" style="margin-left: 4px">&sum;</span>
                  </div>
                  <filter-select
                    noTag
                    @blur="input.isLoading = false"
                    :isLoading="input.isLoading"
                    @search="(s) => searchWithoutDelay(s, input)"
                    @addNew="(name) => addNew(input, name)"
                    :addNewEnable="input.isEditable"
                    multiple
                    @select="(e) => inputMaterial(e, input)"
                    hide-label
                    @focus="searchWithoutDelay('', input)"
                    @remove="(e) => removeMaterial(e, input)"
                    v-model="input.value"
                    @input="inputOption(input)"
                    :label="input.name" :options="sortOptions(filterMaterials(input) || [], input.value, input)">
                  </filter-select>
                </div>


                <div v-if="input.type === 'select' || input.type === 'zone'">
                  <div class="material-title" style="margin-bottom: 8px; margin-top: 10px">
                    <strong style="color: black;">{{ input.name }}
                    </strong>
                    <span
                      v-if="showCalc(input.volumeId) && input.type.includes('multiple')"
                      @click="toFactMultiple(input)"
                      class="sum-icon" style="margin-left: 4px">&sum;</span>
                  </div>
                  <filter-select
                    noTag
                    :disabled="approve"

                    @blur="input.isLoading = false"
                    @focus="searchWithoutDelay('', input)"
                    :isLoading="input.isLoading"
                    @addNew="(name) => addNew(input, name)"
                    :addNewEnable="input.isEditable"
                    :multiple="input.type.includes('multiple')"
                    @input="(opt) => inputOption(input, opt)"
                    hide-label
                    @search="(s) => searchWithoutDelay(s, input)"
                    v-model="input.value"
                    :label="input.name"
                    :options="sortOptions(input.type.includes('multiple') ? (filterMaterials(input) || []) : (input.options || []), input.value, input)">
                  </filter-select>
                </div>

                <div v-if="input.type === 'population'" style="margin-bottom: 8px; margin-top: 10px;">
                  <div style="color: black; display: flex">
                    {{ input.name }}
                    <add-prof-tech-to-job
                      v-if="!(user.role === 'admin' && user &&  user.usePermission) && !isWorker"
                      :mainForm="form.job"
                      @save="saveProf" :table="form.PROF || []" :workTypeOptions="workTypeOptions" type="PROF"/>
                  </div>
                  <template v-if="!isWorker">
                    <el-row style="margin-top: 8px">
                      <el-col :span="12">
                        <el-form-item>
                          <el-input disabled style="margin-right: 8px" :value="`${planFactProf.value || 0} кол-во`">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-if="available_reports && available_reports[`PROF_TIME`]">
                        <el-form-item>
                          <el-input disabled style="margin-left: 8px"
                                    :value="`${(planFactProf.total)} часы`"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else>
                    <el-row style="margin-top: 8px">
                      <el-col :span="8">
                        <el-form-item>
                          <el-input
                            type="number"
                            @input="handlerFactProf"
                            v-model="form.job.factProf" placeholder="Кол-во">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" v-if="available_reports && available_reports[`PROF_TIME`]">
                        <el-form-item>
                          <el-input
                            type="number"
                            @input="() => {
                              form.job.timeProf = (form.job.profSm* form.job.factProf) || ''
                            }"
                            placeholder="Смена"
                            v-model="form.job.profSm"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" v-if="available_reports && available_reports[`PROF_TIME`]">
                        <el-form-item>
                          <el-input
                            type="number"
                            placeholder="Часы"
                            v-model="form.job.timeProf"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </template>

                </div>


                <template v-if="input.type === 'nomenclature'">
                  <NomenclatureInput
                    :options_works="options_works"
                    :job="form"
                    :work_type="form.job.work_type"
                    :dirs="dirs"
                    @toFact="toFactNomenclature" :selectValuesProp="input.selectValues" :nomenclature="input"
                    @save="(e) => saveNomennclature(e, input)"/>
                </template>

                <div v-if="input.type === 'tech'"
                     style="    margin-bottom: 8px; margin-top: 10px; display: flex; align-items: flex-start; flex-direction: column">
                  <div style="color: black; display: flex">
                    {{ input.name }}
                    <add-prof-tech-to-job
                      v-if="!(user.role === 'admin' && user &&  user.usePermission)"
                      :mainForm="form.job"
                      @save="saveTech" :table="form.TECH || []" :workTypeOptions="workTypeOptions" type="TECH"/>
                  </div>
                  <el-row style="margin-top: 8px">
                    <el-col :span="12">
                      <el-form-item>
                        <el-input disabled style="margin-right: 8px" :value="`${planFactTech.value || 0} кол-во`">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="available_reports && available_reports[`TECH_TIME`]">
                      <el-form-item>
                        <el-input disabled style="margin-left: 8px"
                                  :value="`${(planFactTech.total || 0)} часы`"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="report-file">
          <UploadFile
            :disabled="this.form.timesheetId || approve"
            :fileListProps="fileList"
            @add-file="addFile"
          />
          <div :key="index" v-for="(file, index) in form.files" class="links-list">
            <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
            <i class="el-icon-delete" :class="{'disable-report':  approve}" @click="deleteImg(index)"></i>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button
            v-if="editIndex !== null && editIndex !== undefined && !approve"
            @click="removeReportClick"
            style="margin-left: 0; padding: 12px 8px"
            type="danger"
          >Удалить
          </el-button>
          <el-button
            :loading="loader" :disabled="loader"
            v-if="!approve"
            style="margin-left: 0; padding: 12px 8px"
            @click="save"
            type="primary"
          >Сохранить
          </el-button>
          <el-button style="margin-left: 0; padding: 12px 8px" @click="clear">
            Закрыть
          </el-button>
        </div>
      </template>


    </el-dialog>

    <AddNewOption :isEditable="isEditable" @close="" ref="addNewOption" @new-option="addNewInput"/>
    <el-dialog
      :show-close="false"
      :title="selectMaterial.label"
      :visible.sync="openDialogMaterials"
      width="30%"
      center
    >
      <div v-if="selectMaterial && selectMaterial.details">
        <template v-if="!selectMaterial.type.includes('multiple')">
          <el-input
            :controls="false"
            style="margin-top: 4px"
            :disabled="approve"
            type="number"
            @input="inputMat(selectMaterial)"
            placeholder="Значение"
            v-model="selectMaterial.fact"
            class="input-with-select">
            <template slot="append">{{ selectMaterial.details[1] && selectMaterial.details[1].label }}</template>
          </el-input>
          <div style="display: flex; align-items: center; margin-top: 8px">
            <span v-if="!selectMaterial.withoutPlan">План: <strong>{{ selectMaterial.details[2] || 0 }}</strong></span>
          </div>


          <template v-if="selectMaterial.type.includes('constructions')">
            <el-input
              :controls="false"
              style="margin-top: 22px"
              :disabled="approve"
              type="number"
              placeholder="Значение"
              v-model="selectMaterial.factUnit"
              class="input-with-select">
              <template slot="append">{{ selectMaterial.details[3] && selectMaterial.details[3].label }}</template>
            </el-input>
            <div style="display: flex; align-items: center; margin-top: 8px" v-if="!selectMaterial.withoutPlan">
              <span>План на ед: <strong>{{ selectMaterial.details[4] || 0 }}</strong></span>
            </div>
          </template>
        </template>

        <div v-if="selectMaterial.isDetail" style="margin-top: 22px">
          <el-input v-model="selectMaterial.detail" placeholder="Примечание"></el-input>
        </div>

        <div style="display: flex; align-items: center; margin-top: 12px"
             v-if="!selectMaterial.withoutPlan && !selectMaterial.type.includes('multiple')">
          <el-checkbox
            v-model="selectMaterial.inVolume"
            label="в объем"
          ></el-checkbox>
        </div>
      </div>

      <div style="margin-top: 32px; display: flex; justify-content: flex-end">

        <el-button :loading="loader" :disabled="loader" type="primary" @click="saveMaterial(true)" v-if="!approve">
          Сохранить
        </el-button>
        <el-button @click="closeMaterial">Закрыть</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="addProffModal">

      <ListJobs
        isModal
        ref="listJob"
        :dirs="dirs"
        :originalForm="form"
        type="PROF"
        :props-form="childForm.PROF"
        :options_works="options_works"
      />
    </el-dialog>
  </div>
</template>

<script>
import JobsCreate from '../../Jobs/Create';
import MaterialsCreate from '../../Jobs/Materials';
import {BigNumber} from "bignumber.js";
import UnitSelect from '../../components/unitSelect';
import FilterSelect from "../../../../components/FilterSelect";
import AddNewOption from "../../Reports/components/AddNewOption";
import {v4 as uuidv4} from "uuid";
import _, {debounce, orderBy} from "lodash";
import {getUsersOptions} from "../../../../firestore/users";
import UploadFile from "../../Reports/components/UploadFile";
import firebase from "firebase";
import {getZonesOptions} from "../../../../firestore/inputs";
import AddProfTechToJob from "./AddProfTechToJob";
import dayjs from "dayjs";
import SearchReports from "./SearchReports";
import NomenclatureInput from "../../Reports/components/NomenclatureInput";
import CyrillicToTranslit from "cyrillic-to-translit-js";

import ListJobs from "../../Reports/components/ListJobs";
import {getPermission, getRole} from "../../../../firestore/permission";
import {toFixedWithoutZero, toFloat} from "../../../../utils/numberUtils";
import job from "../../Analytics/Job";
import {isCache} from "../../../../plugins/firebase";
import {filterJobs} from "../../../../utils/filterJobs";


function percentage(num, per) {
  return new BigNumber(num).dividedBy(100)
    .multipliedBy(per).toNumber()
}


export default {
  name: 'AddJobs',
  components: {
    ListJobs,
    NomenclatureInput,
    SearchReports,
    AddProfTechToJob, UploadFile, AddNewOption, FilterSelect, MaterialsCreate, JobsCreate, UnitSelect
  },
  props: ['job', 'approve', 'isWorker', 'index',
    'isObject', 'workTypeOptions', 'report', 'isNotWorkSt', 'mainForm', 'user', 'approve', 'options_works', 'isEditable', 'dirs'],
  inject: ['timeProfGlobal'],
  data() {
    return {
      permission: null,
      dialogObjectSearch: false,
      fileList: [],
      calcValue: 0,
      loadingCheck: false,
      calcPlan: 0,
      addProffModal: false,
      formIndex: 0,
      isLoad: false,
      copyJobOpen: false,
      role: '',
      structureObj: null,
      search: '',
      jobs: [],
      isNotWork: false,
      prevZone: null,
      dialogObject: false,
      loadingCopy: false,
      openDialogMaterials: false,
      openUid: null,
      currentIndexReport: null,
      isEdit: false,
      originalId: null,
      reports: [],
      obj: {},
      selectAll: false,
      isCreateJob: true,
      jobOptions: [],
      usersOptions: [],
      input: {},
      editIndex: null,
      loader: false,
      fetchLoader: false,
      shifts: [{
        label: 1,
        value: 1,
      }, {
        label: 2,
        value: 2,
      }, {
        label: 3,
        value: 3,
      }],
      editProf: {},
      isCreateCustom: null,
      zoneLock: false,
      reportPROFIndex: null,
      reportPROF: null,
      childForm: {
        PROF: {
          jobs: [[]],
          jobs_internal: [],
          work_type: [],
          work_type_dir: [],
          turn: {
            value: 1,
            label: 1,
          },
          daily_plan: {
            workers: '',
            itr: '',
          },
        },
        TECH: {
          jobs: [[]],
          jobs_internal: [],
          work_type: [],
          work_type_dir: [],
          turn: {
            value: 1,
            label: 1,
          },
          daily_plan: {
            workers: '',
            itr: '',
          },
        }
      },
      profValue: {
        time: 0,
        fact: 0
      },
      selectMaterial: {},
      techValue: {
        time: 0,
        fact: 0
      },
      insertJob: {},
      form: {
        user: null,
        turn: {
          label: 1,
          value: 1
        },
        daily_plan: '',
        value: '',
        comment: '',
        job: {
          profSm: '',
          timeProf: ''
        },
        files: [],
        datetime: dayjs().format(),
        TECH: {},
        PROF: {},
      },
      datetime: dayjs().format('DD.MM.YYYY')

    };
  },

  async mounted() {
    this.role = await getRole(this.$store.state.project.id);
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);

    this.fetchJobs();
    this.available_reports = this.$store.state.project.available_reports;
    const users = await getUsersOptions(this.$store.state.project.id, true)
    this.usersOptions = users.filter((u) => u._data.isCompany)
    this.$emit('isInit')

  },
  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    planFactTech() {
      let total = 0

      if (this.form.TECH && this.form.TECH.jobs) {
        this.form.TECH.jobs.forEach((job) => {
          total += BigNumber(Number(job.time || 0)).multipliedBy(Number(job.value || 0)).toNumber();
        })
      }
      return {
        plan: Number(this.form.TECH.plan),
        value: Number(this.form.TECH.value),
        time: Number(this.form.TECH.time),
        total
      }
    },
    planFactProf() {
      let total = 0

      if (this.form.PROF && this.form.PROF.jobs) {
        this.form.PROF.jobs.forEach((job) => {
          total += BigNumber(Number(job.time || 0)).multipliedBy(Number(job.value || 0)).toNumber();
        })
      }
      return {
        plan: Number(this.form.PROF.plan),
        value: Number(this.form.PROF.value),
        time: Number(this.form.PROF.time),
        cleanValue: Number(this.form.PROF.cleanValue),
        cleanTime: Number(this.form.PROF.cleanTime),
        total
      }
    },
  },
  watch: {
    'form.job': {
      deep: true,
      async handler(job = {}) {
        if (!job) {
          return
        }
        const n = job && job.inputs || []

        const nextZone = n.find(({id}) => id === 'zone')
        if ((nextZone && nextZone.value && nextZone.value.value) !== (this.prevZone && this.prevZone.value && this.prevZone.value.value)) {
          let inputs = [...((this.form.job && this.form.job.inputs) || [])]

          inputs = inputs.map((input) => {
            if ((input.type.includes('materials') || input.type.includes('constructions') || input.type.includes('multiple')) && !this.zoneLock) {
              return {
                ...input,
                options: [...(input.options || [])].map((option) => {
                  if (!option.isZone && !option.zoneId) {
                    return option
                  }
                  return {
                    ...option,
                    label: option.value
                  }
                }),
                value: [...(input.value || [])].filter((v) => !v.zoneId)
              }
            }

            if (input.type === 'zone') {

              const work = this.options_works.find(({id}) => job && id === job.work_type)

              if (work && work.dir) {
                const dir = this.dirs.find(({id}) => id === work.dir);

                if (dir && dir.defaultZone && !input.value) {
                  setTimeout(() => {
                    input.value = input.options.find((d) => dir.defaultZone === d.value);
                  }, 1000)
                }

                if (dir && dir.usePermission) {
                  input.options = input.options.filter((d) => dir.available_objects.includes(d.value) || !d.value)
                }
              }
            }

            return input
          })

          this.form.job = {
            timeProf: '',
            profSm: '',
            ...this.form.job,
            inputs,

          }
        }


        this.prevZone = {...nextZone};
      }
    },
  },
  methods: {
    isShow(obj) {
      if(this.isNotWork) {
        return this.filteredList.find((d) => {
          return d.id === obj.id && Number(Number(d.totalValue || 0).toFixed(3)) < Number(Number(d.plan).toFixed(3))
        })
      } else {
        return this.filteredList.find((d) => d.id === obj.id)
      }
    },
    dayjs,
    checkboxSelect() {
      this.filteredList.forEach((j) => {
        const index = this.jobs.findIndex(({id}) => j.id === id)
        if (index !== -1) {

          this.jobs[index].isSelect = this.selectAll
        }
      })

      this.jobs = [...this.jobs]
    },
    backToReport() {
      if (this.form.job && this.editIndex !== null) {
        this.form.job = null
      } else {
        this.saveToReport(true)
      }
    },
    setAllSelect(jobs, flag) {
      if (!jobs) {
        this.jobs = this.jobs.map((d) => {
          d.isSelect = flag
          return d
        })
      } else {
        this.jobs = this.jobs.map((d) => {
          d.isSelect = !!jobs.find((j) => j.job.id === d.id)
          return d
        })
      }

      return this.jobs;
    },
    saveToReport(flag) {
      const jobs = this.jobs.filter(({isSelect}) => isSelect)
      const result = []

      const form = JSON.parse(JSON.stringify(this.form))


      jobs.forEach((job) => {
        form.job = job
        form.daily_plan = (job.volumes && job.volumes.length) ? toFixedWithoutZero(job.volumes[this.mainForm.turn.value - 1][this.datetime]) : ''

        if (form) {
          const job_form = JSON.parse(JSON.stringify(form.job))

          try {
            job_form.inputs = job_form.inputs.map((r) => {
              delete r.permission;
              delete r.dir
              delete r.dirs

              delete r.defaultFields
              delete r.options

              return r
            })
          } catch (e) {
            job_form.inputs = []
          }

          delete job_form.volumes
          delete job_form.volumes_prof
          delete job_form.volumes_tech
          delete job_form.project
          delete job_form.permission
          form.job = job_form
        }

        form.job.allPlan  = toFixedWithoutZero(this.calcPlan || form.job.plan);
        form.job.allValue = toFixedWithoutZero(this.calcValue);


        if (this.isWorker) {
          // form.job.profSm = this.timeProfGlobal.value || form.job.profSm
          form.job.timeProf = form.job.timeProf || ''
          form.job.factProf = form.job.factProf || ''
        } else {
          form.job.factProf = this.planFactProf.cleanValue || ''
          form.job.timeProf = this.planFactProf.cleanTime || ''

        }

        form.job.factTech = this.planFactTech.value || ''
        form.job.timeTech = this.planFactTech.total || ''


        form.uid = uuidv4();

        form.value = form.value || ''

        result.push({
          ...form,
          daily_plan: form.daily_plan || ''
        })
      })

      if (this.isObject) {
        this.$emit(flag ? 'back-add' : 'mass-add', {result, obj: this.obj})
      } else {

        result.forEach((form) => {

          this.$emit('save', {
            form: form,
            structureObj: this.structureObj,
            editIndex: this.editIndex,
            obj: this.obj
          })
        })

      }
      this.clear()
      this.dialogObject = false;
    },
    setSearch(s) {
      this.search = s
    },
    handlerFactProf() {
      // !this.form.job.profSm ? this.form.job.profSm = this.timeProfGlobal.value : this.form.job.profSm = this.form.job.profSm;
      this.form.job.profSm = this.timeProfGlobal.value
      this.form.job.timeProf = (this.form.job.profSm * this.form.job.factProf) || ''
    },
    backHandler() {
      if (!this.form.job) {
        this.clear();
        this.dialogObject = false;
      } else {
        this.form.job = null
      }
    },
    handleSelectOption(item) {
      this.form.job.unit = item.data.unit
    },
    querySearch(queryString, cb) {
      const results = this.jobOptions
        .filter(job => job.name.toLowerCase().startsWith(queryString.toLowerCase()))
        .map(job => ({value: job.name, data: job}));
      cb(results);
    },
    createCustom() {
      this.form.job = {
        name: '',
        unit: '',
        id: '01',
        work_type: 'custom',
        dir: null
      }
      this.selectJob(this.form.job)
      this.fetchJobOptions();
      this.isCreateCustom = true
    },
    valueMaterials(n) {

      if (n.match(/^[0-9]+$/) || /%$/.test(n) || /,$/.test(n) || /.$/.test(n) || !String(n).length) {
        this.form.value = String(n).replace(',', '.');

        if (/%$/.test(n) && this.form.job.plan) {
          return this.total_p = percentage(Number(this.form.job.plan), Number(this.form.value.replace('%', '')));
        } else {

          this.total = new BigNumber(String(this.form.value).replace(',', '.'))
            .multipliedBy(String(this.form.job.unit_value).replace(',', '.')).toNumber()
        }

        this.total_p = null;
      }
    },
    createJob() {
      this.isCreateJob = true;
    },
    async fetchJobOptions() {
      const objData = await this.fire()
        .collection('autocomplete')
        .where('obj', '==', (this.obj && this.obj.id || 'all'))
        .get()

      const result = [];

      objData.forEach((subData) => {
        result.push(subData.data())
      })

      this.jobOptions = result;
    },

    async fetchJobs(flag) {
      this.fetchLoader = true
      let req = null;
      this.isCreateJob = false;

      const path = 'JOBS_' + JSON.stringify({
        type: (this.type || this.$route.params.type),
        obj: [this.obj && this.obj.id || 'all']
      })

      if (this.obj && this.obj.id === null) {
        this.fetchLoader = false
        return

      }
      const cache = null

      if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
        let objCustom = null
        if (flag) {
          const lastPart = this.obj.name.split('>').pop().trim();
          const objData = await this.fire(true)
            .collection('objects')
            .where('name', '==', lastPart)
            .get()

          objData.forEach((subDoc) => {
            objCustom = subDoc.id;
          })
        }
        req = this.fire(flag)
          .collection('jobs')
          .where('type', '==', 'JOB')
          .where(`objects`, 'array-contains-any', [objCustom || (this.obj && this.obj.id || 'all')]);
        console.log('get jobs 4')
        let result = [];
        req.get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              const work_type = this.options_works.find(({id}) => id === data.work_type)

              if (flag) {
                result.push({
                  ...data,
                  isSelect: false,
                  id: subDoc.id,
                  totalValue: 0,
                  plan: 0,
                  price_plan: 0,
                  unit_for_value: Number((work_type && work_type._data && work_type._data.unit_for_value) || 0),
                  price_unit: 0,
                });
              } else {
                result.push({
                  isSelect: false,
                  id: subDoc.id,
                  unit_for_value: Number((work_type && work_type._data && work_type._data.unit_for_value) || 0),
                  ...data,
                });
              }

            });
          })
          .finally(() => {
            if (isCache) {
              localStorage.setItem(path, JSON.stringify({result, expire: dayjs().add(10, 'minute').unix()}))
            }

            const result_filter = (result) => {
              // if ((this.type || this.$route.params.type) === 'JOB') {
              return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
              // }
            }


            this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);
            this.fetchLoader = false

          });

      } else {

        const result = JSON.parse(cache).result
        const result_filter = (result) => {
          if ((this.type || this.$route.params.type) === 'JOB') {
            return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
          }

          return result
        }

        this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);

        if ((this.type || this.$route.params.type) === 'JOB' || (this.type || this.$route.params.type) === 'MATERIALS') {
          req = this.fire()
            .collection('jobs')
            .where('type', '==', (this.type || this.$route.params.type))
            .where(`objects`, 'array-contains-any', [this.obj && this.obj.id || 'all']);
        } else {
          req = this.fire()
            .collection('jobs')
            .where('type', '==', (this.type || this.$route.params.type));
        }
        console.log('get jobs 5')



        let resultr = [];
        req.get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              resultr.push({
                id: subDoc.id,
                ...data,
              });
            });
          })
          .finally(() => {
            if (isCache) {
              localStorage.setItem(path, JSON.stringify({result: resultr, expire: dayjs().add(10, 'minute').unix()}))
            }

            const result_filter = (result) => {
              if ((this.type || this.$route.params.type) === 'JOB') {
                return filterJobs(result, this.permission, this.obj && this.obj.id || 'all');
              }

              return result
            }

            this.jobs = _.orderBy(result_filter(result), 'index', ['asc']);
            this.fetchLoader = false

          });
      }
    },
    toFixedWithoutZero,
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 85) {
        return '#F57C00'
      }

      return '#D32F2F'
    },
    findPercentage(a, b) {
      if (!a) {
        return 0
      }

      if (!b) {
        return 100
      }


      return Number((Number(a || 0) / Number(b)) * 100).toFixed(0);
    },
    toFactNomenclature(result) {
      this.form.value = result
      this.form = {...this.form}
    },
    searchWithoutDelay(search, input) {
      if (!input.type.includes('L')) {
        return
      }
      const index = this.form.job.inputs.findIndex(({id}) => id === input.id)
      this.form.job.inputs[index].isLoading = true
      this.form.job = {
        ...this.form.job,
      }
      this.searchL(search, input)
    },
    searchL: debounce(async function (search, input) {
      const index = this.form.job.inputs.findIndex(({id}) => id === input.id)
      this.form.job.inputs[index].isLoading = true
      this.form.job = {
        ...this.form.job,
      }

      const zone = this.form.job.inputs.find(({id}) => id === 'zone')
      if (!input.type.includes('L')) {
        return
      }
      input.isLoading = true


      let resp = null


      if (search && search.length) {
        const cyrillicToTranslit = new CyrillicToTranslit();


        const txt = String(cyrillicToTranslit.transform(search).toLowerCase())
        const txtArray = txt.split(' ')
        const query = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(input.id)
          .collection('optionsList')
          // .where('searchName', '<=', txt + '\uf8ff')
          .where('searchName', 'array-contains', txtArray[txtArray.length - 1])

        if (zone && zone.value && zone.value.value) {
          query.where('zoneId', '==', zone.value.value)
        }

        resp = await query.limit(100).get()
      } else {
        if (zone && zone.value && zone.value.value) {
          resp = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .orderBy('index', 'asc')
            .where('zoneId', '==', zone.value.value).limit(100).get()
        } else {
          resp = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(input.id)
            .collection('optionsList')
            .orderBy('index', 'asc')
            .limit(100).get()
        }
      }

      const result = []
      resp.forEach((d) => {
        result.push(
          {
            id: d.id,
            ...d.data(),
          }
        )
      })

      this.form.job.inputs[index].options = [...orderBy(result, 'index', 'asc')]

      this.form.job.inputs[index].isLoading = false
      this.form.job = {
        ...this.form.job,
      }
    }, 500),
    saveNomennclature(d, input) {
      const index = this.form.job.inputs.findIndex(({id}) => input.id === id)
      this.form.job.inputs[index].selectValues = d
      if (!this.form.job.inputs[index].selectValues || !Object.keys(this.form.job.inputs[index].selectValues).length) {
        this.form.job.inputs[index].selectValues = null
      }

      this.form.job = {...this.form.job}
    },
    doCopy() {
      this.form.reportId = null
      this.copyJobOpen = false
      this.editIndex = null
      this.save(true)
    },
    saveCopy(e) {
      this.$emit('save', {
        ...e,
        structureObj: this.structureObj,
        isEdit: this.isEdit,
        editId: null
      })
      this.dialogObject = false
      this.clear()
    },
    async removeReportClick() {

      this.$emit('remove', {
        structureObj: this.structureObj,
        editIndex: this.editIndex
      })

      this.dialogObject = false;
      this.clear()
    },
    async fetchParent() {
      let query = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('workorders').where('index', '==', this.form.workOrderIndex).get()

      let data = {}

      query.forEach((d) => {
        data = {
          id: d.id,
          data: d.data()
        }
      })

      return data;
    },
    selectJobInsert(job) {
      if (job.user && job.executor) {
        job.user = {
          ...job.executor,
          label: job.executor.name,
          value: job.executor.uid,

        }
      }
      this.openJob(job)

      this.openUid = true
      this.dialogObjectSearch = false
    },
    fire(flag) {
      if (flag) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
      }

      if (this.$route.query.version) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id)) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },

    getCurrentObj() {
      try {
        const obj = this.mainForm.inputObjects.find(({id}) => id === this.structureObj);
        return obj.jobs[this.editIndex]
      } catch (e) {
        return null
      }
    },
    async save() {
      this.form.value = toFloat(this.form.value);
      this.loader = true;

      this.loader = false;


      if (this.form) {
        const job_form = JSON.parse(JSON.stringify(this.form.job))

        job_form.inputs = job_form.inputs.map((r) => {
          delete r.permission;
          delete r.dir
          delete r.dirs

          delete r.defaultFields
          delete r.options

          return r
        })

        delete job_form.volumes
        delete job_form.volumes_prof
        delete job_form.volumes_tech
        delete job_form.project
        delete job_form.permission
        this.form.job = job_form
      }

      this.form.job.allPlan = toFixedWithoutZero(this.calcPlan || this.form.job.plan);
      this.form.job.allValue = toFixedWithoutZero(this.calcValue);
      this.form.job.profSm = this.form.job.profSm || this.timeProfGlobal.value


      if (this.isWorker) {
        this.form.job.profSm = this.form.job.profSm || this.timeProfGlobal.value
        this.form.job.timeProf = this.form.job.timeProf || ''
        this.form.job.factProf = this.form.job.factProf || ''
      } else {
        this.form.job.factProf = this.planFactProf.cleanValue || ''
        this.form.job.timeProf = this.planFactProf.cleanTime || ''
      }

      this.form.job.factTech = this.planFactTech.value || ''
      this.form.job.timeTech = this.planFactTech.total || ''


      this.form.uid = this.form.uid || uuidv4();

      this.form.value = this.form.value || ''

      if (this.isCreateCustom) {
        const name = this.form.job.name.trim();
        const unit = this.form.job.unit.trim();
        const objId = (this.obj && this.obj.id) || 'all';
        const exists = this.jobOptions.some(job => job.name.toLowerCase() === name.toLowerCase());

        if (!exists) {

          await this.fire().collection('autocomplete').add({
            name,
            unit,
            obj: objId
          });

          this.jobOptions.push({name, unit});
        }
      }
      this.$emit('save', {
        form: this.form,
        structureObj: this.structureObj,
        editIndex: this.editIndex,
        obj: this.obj
      })

      this.clear()
      this.dialogObject = false
    },
    saveProf(prof) {
      this.form.PROF = prof;

      this.form = {...this.form}
    },
    saveTech(tech) {
      this.form.TECH = tech;
      this.form = {...this.form}

    },
    async selectJob(job = {}) {

      this.loader = true
      if (!job) {
        job = {}
      }

      this.form.job = {
        profSm: '',
        ...(this.form.job || {}),
        fact: 0,
        inputs: job.inputs || [],
        ...job,
        reports: job.reports,
      }


      this.savedJob = {
        ...this.savedJob,
        inputs: job.inputs || []
      }


      if (this.form.job) {
        let dir = {dir: null};
        let zones = []
        let result = []

        if (this.form.job && this.form.job.work_type) {
          dir = (await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('works_type')
            .doc(this.form.job.work_type.value || this.form.job.work_type).get()).data()
        }

        const zoneDirs = this.$store.state.project.zoneDirs || []


        if (zoneDirs.includes(((dir && dir.dir) || 'all'))) {
          zones = await getZonesOptions(this.$store.state.project.id)
          if (this.savedJob && this.savedJob.inputs) {
            const v = this.savedJob.inputs.find(({id}) => id === 'zone')

            if (v) {
              result.push({
                options: zones,
                name: 'Зона работы',
                index: 0,
                type: 'zone',
                value: v.value,
                id: 'zone'
              })
            } else {
              result.push({
                options: zones,
                name: 'Зона работы',
                index: 0,
                type: 'zone',
                value: null,
                id: 'zone'
              })
            }
          }
          result = [...result]
        }

        const inputs = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .where(`dirs`, 'array-contains-any', [(dir && dir.dir) || 'all'])
          .get()


        inputs.forEach((input) => {
          const data = input.data();

          if (!data.type) {
            data.type = {
              label: 'Текст',
              value: 'text',
            }
          }
          delete data.checked;
          const dataResult = {
            ...data,
            options: data.options,
            type: data.type.value || data.type,
            value: null,
            id: input.id
          }

          if (this.savedJob && this.savedJob.inputs) {
            const v = this.savedJob.inputs.find(({id}) => id === input.id)
            if (v) {
              dataResult.value = v.value
              dataResult.selectValues = v.selectValues || null
            }
          }

          result.push({...dataResult})
        })


        if (result) {
          this.form.job.inputs = _.orderBy(result, 'index', ['asc'])
        } else {
        }

        this.form.job = {...this.form.job, reports: job.reports}
        this.form = {...this.form}

        this.loader = false

        const datetime = dayjs(this.mainForm.datetime).format('DD.MM.YYYY');
        try {
          this.form.daily_plan = this.form.job.volumes[this.mainForm.turn.value - 1][datetime] || '';
          return this.form.daily_plan
        } catch (e) {
          return this.form.daily_plan;
        }
      }
    },
    async openJob(job) {
      this.dialogObject = true
      this.selectJob(job.jobs[0].job || {})

      this.originalId = job.originalId


      // console.log(this.form.job.inputs, 'this.form.job.inputs')

      this.form = {
        ...this.form,
        value: job.jobs[0].job.value,
        ...job,
        plan: job.plan,
        PROF: job.PROF || {},
        TECH: job.TECH || {}
      }

      if (this.form.reportPROF) {
        const prof = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports').doc(this.form.reportPROF).get()

        const report = prof.data()
        if (report) {
          this.form.PROF = {...report.PROF, ...this.form.PROF}
          this.form.PROF.jobs = (report.jobs && report.jobs[0]) || [];
          this.editProf = report
        }
      }

      if (job.jobs && job.jobs[0]) {
        this.form.job.comment = job.jobs[0].comment
      }
    },
    async open(job = null, index, id, obj, isLoad) {
      this.selectAll = false
      this.datetime = dayjs(this.mainForm.datetime).format('DD.MM.YYYY')


      this.isNotWork = this.isNotWorkSt;
      if (isLoad) {
        this.isLoad = isLoad
      } else {
        this.isLoad = false
      }

      this.form.job = job;
      this.structureObj = id
      this.editIndex = index;

      this.obj = obj;

      await this.fetchJobs()
      this.dialogObject = !isLoad

      if (this.form.job) {
        this.dialogObject = !isLoad

        await this.selectJob({...job.job, reports: job.reports} || {})


        try {
          if (this.form.job.inputs.length && !job.job.inputs.length) {
            job.job.inputs = this.form.job.inputs
          } else if (this.form.job.inputs.length) {
            job.job.inputs = job.job.inputs.map((input) => {
              try {
                input.options = (this.form.job.inputs.find((z) => z.id === input.id)).options
              } catch (e) {
              }
              return input
            })
          }

        } catch (e) {
        }
        this.reports = job.reports || []
        this.originalId = job.originalId


        this.form = {
          ...this.form,
          ...job,
          plan: job.plan,
          PROF: job.PROF || {},
          TECH: job.TECH || {}
        }

        this.calcPlan = this.form.plan
      }
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    addFile(f) {
      this.form.files.push(f);
    },
    openAddProf() {
      this.form.uid = this.form.uid || uuidv4()
      this.$emit('add-prof', {
        uid: this.form.uid,
        job: this.form.job
      })
    },
    inputMaterial(e, input) {
      if (input.type !== 'multiple' || input.isDetail) {
        this.openDialogMaterials = true
      }
      this.selectMaterial = {
        ...e,
        fact: '',
        factUnit: '',
        detail: '',
        withoutPlan: input.withoutPlan,
        isDetail: input.isDetail,
        inVolume: input.type === 'constructions',
        parentId: input.id,
        type: input.type
      };
    },
    removeMaterial(e, input) {
      const index = input.options.findIndex(({uid, value, label}) => uid === e.uid && value.trim() === e.value.trim())

      if (index !== -1 && input.options.filter((o) => o.uid === e.uid).length > 1) {
        input.options.splice(index, 1)
      }
      this.form = {...this.form}
    },
    filterMaterials(input) {
      try {
        if (!input.isZone) {
          return [...(input.options || [])].filter((option) => !option.zoneId)
        }

        const zone = this.form.job.inputs.find(({id}) => id === 'zone').value || {value: 'all'}
        return [...(input.options || [])].filter((option) => !option.zoneId || option.zoneId === zone.value);
      } catch (e) {
        return []
      }
    },
    sortOptions(options, value) {
      if (Array.isArray(value)) {
        const values = value || [];

        const optionsWithoutValues = options.filter((o) => !(values || []).find((v) => v.uid === o.uid && v.value === o.value));

        return [..._.orderBy(values, ['label'], ['desc']), ...optionsWithoutValues] //_.orderBy(options, ['label'], ['desc'])
      } else {
        return options
      }
    },
    toFact(input) {
      let result = 0

      input.value.forEach((value) => {
        if (value.inVolume) {
          result = new BigNumber(result)
            .plus(input.type === 'constructions' ? value.factUnit : value.fact).toNumber()
        }
      })

      this.form.value = result
      this.form = {...this.form}
    },
    saveMaterial(flag) {
      /// НЕ ТРОГАТЬ
      const index = this.form.job.inputs.findIndex(({id}) => this.selectMaterial.parentId === id)

      const option = this.form.job.inputs[index].options.find(({value}) => value === this.selectMaterial.value);
      if (!option) {
        this.form.job.inputs[index].options.push({
          details: this.selectMaterial.details,
          id: this.selectMaterial.id,
          index: this.selectMaterial.index,
          isCreate: this.selectMaterial.isCreate,
          label: this.selectMaterial.label,
          uid: this.selectMaterial.uid,
          value: this.selectMaterial.value,
          zoneId: this.selectMaterial.zoneId
        })

      }
      // options.find(({value}) => )
      const childIndex = this.form.job.inputs[index].options.findLastIndex(
        ({
           uid,
           value,
           label
         }) => uid === this.selectMaterial.uid
          && this.selectMaterial.value.trim() === value.trim()
          && this.selectMaterial.label.trim() === label.trim()
      );

      if (this.selectMaterial.isDetail && this.form.job.inputs[index].options[childIndex]) {
        const input = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex]))
        const option = {
          ...JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex])),
          value: JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex])).value,
          label: input.originalLabel || input.label,
        }

        this.form.job.inputs[index].options.push({...option})
      }


      if ((this.selectMaterial.type.includes('multiple') || flag) && this.form.job.inputs[index].options[childIndex]) {
        this.form.job.inputs[index].options[childIndex].label = '' + this.selectMaterial.value + (this.selectMaterial.fact ? ' - ' + this.selectMaterial.fact : '') + ' ' + ((this.selectMaterial.details[1] && this.selectMaterial.details[1].label) || '')
      }


      // if(this.selectMaterial.type === 'materials') {
      this.form.job.inputs[index].options[childIndex].originalLabel = '' + this.form.job.inputs[index].options[childIndex].value
      // }

      if (this.selectMaterial.type.includes('multiple')) {
        try {

          const trueKeys = Object.keys(this.form.job.inputs[index].volumeId).filter(key => this.form.job.inputs[index].volumeId[key] === true);

          const details = this.form.job.inputs[index].options[childIndex].details
          if (trueKeys && trueKeys.length) {
            let sumKey = 0;
            let label = ''

            trueKeys.forEach((key) => {
              if (details[key] && !isNaN(details[key])) {
                sumKey += Number(details[key])
                label = this.form.job.inputs[index].labels[key]
              }
            })


            this.form.job.inputs[index].options[childIndex].originalLabel = '' + this.form.job.inputs[index].options[childIndex].value

            this.form.job.inputs[index].options[childIndex].label = '' + this.selectMaterial.value + ' - (' + sumKey + ' ' + label + ')'
          } else if (!flag) {
            return;
          }
        } catch (e) {
          console.error(e)
          if (!flag) {
            return
          }
        }
      }


      this.form.job.inputs[index].options[childIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].options[childIndex].fact = this.selectMaterial.fact;
      this.form.job.inputs[index].options[childIndex].inVolume = this.selectMaterial.inVolume;


      const valueIndex = this.form.job.inputs[index].value.findLastIndex(({uid}) => uid === this.selectMaterial.uid);

      this.form.job.inputs[index].value[valueIndex].label = this.form.job.inputs[index].options[childIndex].label
      this.form.job.inputs[index].value[valueIndex].fact = this.selectMaterial.fact;
      if (this.selectMaterial.isDetail) {
        this.form.job.inputs[index].value[valueIndex].detail = this.selectMaterial.detail
      }


      if (this.selectMaterial.inVolume && !this.selectMaterial.withoutPlan) {
        this.form.job.inputs[index].options[childIndex].label = '• ' + this.form.job.inputs[index].options[childIndex].label;
        this.form.job.inputs[index].value[valueIndex].inVolume = true
      }

      if (this.form.job.inputs[index].type.includes('constructions')) {
        this.form.job.inputs[index].value[valueIndex].factUnit = this.selectMaterial.factUnit;
        this.form.job.inputs[index].options[childIndex].label += isNaN(this.selectMaterial.factUnit) ? '' :
          (this.selectMaterial.details[3] || this.selectMaterial.factUnit ? ` (${this.selectMaterial.factUnit} ${(this.selectMaterial.details[3] && this.selectMaterial.details[3].label)})` : '')
      }

      if (this.selectMaterial.isDetail && this.selectMaterial.detail) {
        this.form.job.inputs[index].options[childIndex].label += ' (' + this.selectMaterial.detail + ')'
      }


      this.form.job.inputs[index].value[valueIndex].label = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].value[valueIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))
      this.form.job.inputs[index].options[childIndex].value = JSON.parse(JSON.stringify(this.form.job.inputs[index].options[childIndex].label))

      this.form = {...this.form}
      this.openDialogMaterials = false;
      this.selectMaterial = {}

    },
    closeMaterial() {
      this.openDialogMaterials = false;
      const index = this.form.job.inputs.findIndex(({id}) => this.selectMaterial.parentId === id)

      this.form.job.inputs[index].value = this.form.job.inputs[index].value.filter(({
                                                                                      uid,
                                                                                      value
                                                                                    }) => uid !== this.selectMaterial.uid || value !== this.selectMaterial.value)
      this.form.job.inputs = [...this.form.job.inputs]
      setTimeout(() => {
        this.selectMaterial = {}
      }, 200)
    },
    addNew(data, name) {
      this.input = data;
      let zone = null
      try {
        zone = this.form.job.inputs.find(({id}) => id === 'zone').value || null
      } catch (e) {
      }

      this.$refs.addNewOption.open({
        zone,
        data, name
      })
    },
    toFactMultiple(input) {
      let id = Object.values(input.volumeId).findIndex((o) => o)
      let result = 0
      input.value.forEach(({details}) => {
        result += Number(details[id + 1])
      })

      this.form.value = result
      this.form = {...this.form}
    },
    openAddTech() {
      this.form.uid = this.form.uid || uuidv4()
      this.$emit('add-tech', {
        uid: this.form.uid,
        job: this.form.job
      })
    },
    showCalc(obj) {
      try {
        return !!Object.values(obj).find((o) => o)
      } catch (e) {
        return false
      }
    },
    getCalc(input) {
      let n1 = 0
      let n2 = 0

      const findValue = (value) => {
        const res = this.form.job.inputs.find(({id}) => id === value)
        return (res && res.value) || 0
      }


      if (!input.options) {
        return null
      }
      if (input.options && input.options[0].value === 'fact') {
        n1 = this.form.value
      } else {
        n1 = findValue(input.options[0].value)
      }

      if (input.options[1].value === 'fact') {
        n2 = this.form.value
      } else {
        n2 = findValue(input.options[1].value)
      }

      const operators = {
        '+': function (x, y) {
          return Number(x) + Number(y);
        },
        '-': function (x, y) {
          return Number(x) - Number(y);
        },
        '*': function (x, y) {
          return Number(x) * Number(y);
        },
        '/': function (x, y) {
          return Number(x) / Number(y);
        }
      };

      const result = operators[input.operation.value](n1, n2)
      input.value = result

      return result
    },
    clear() {
      this.loader = false;

      this.dialogObject = false
      this.reportPROF = null
      this.form = {
        value: '',
        time: '',
        job: {},
        work_type: {},
        TECH: {},
        PROF: {},
        files: [],
        turn: {
          label: 1,
          value: 1
        },
        daily_plan: '',
        datetime: dayjs().format(),
        comment: '',
      }

      this.jobs = []
      this.savedJob = {}
      this.step = 0;
      this.openUid = false
      this.isCreateCustom = false;
    },
    inputMat(selectMaterial) {
      if (selectMaterial.withoutPlan) {
        return
      }
      selectMaterial.factUnit = new BigNumber(selectMaterial.fact || 0).multipliedBy(selectMaterial.details[4] || 0).toNumber()
    },
    inputOption(input, opt) {

      if (input.type === 'multiple' && input.volumeId && opt) {
        const indexInput = this.form.job.inputs.findIndex(({id}) => input.id === id)

        const index = Object.values(input.volumeId).findIndex((d) => d)
        this.form.job.inputs[indexInput].options = this.form.job.inputs[indexInput].options.map((option) => {
          return {
            ...option,
            label: option.value
          }
        })


        if (input.isDetail) {
          this.openDialogMaterials = true


          this.selectMaterial = {
            ...opt[opt.length - 1],
            fact: '',
            factUnit: '',
            detail: '',
            isDetail: input.isDetail,
            parentId: input.id,
            details: [],
            type: input.type
          };
        }


        opt.forEach((o) => {
          const childIndex = this.form.job.inputs[indexInput].options.findIndex(({uid}) => uid === o.uid);
          const valueIndex = this.form.job.inputs[indexInput].value.findIndex(({uid}) => uid === o.uid);

          this.form.job.inputs[indexInput].options[childIndex].label = o.value + ` ${o.details[index + 1] ? '(' + o.details[index + 1] + ' ' + input.labels[index + 1] + ')' : ''}`;
          this.form.job.inputs[indexInput].value[valueIndex].label = this.form.job.inputs[indexInput].options[childIndex].label
        })
      }

      if (input.type === 'zone') {
        this.zoneLock = false
      }
      this.form = {
        ...this.form
      }
    },
    addNewInput(data, id, value) {
      const index = this.form.job.inputs.findIndex((job) => job.id === id)

      this.form.job.inputs[index] = {
        ...data,
        value: data.type === 'select' ? value : [...(this.form.job.inputs[index].value || []), value],
        id: id
      }

      this.inputOption(this.form.job.inputs[index], this.form.job.inputs[index].value)

      this.form = {
        ...this.form
      }

      if (data.type === 'materials' || data.type === 'constructions') {
        this.openDialogMaterials = true
        const options = this.form.job.inputs[index].options;
        this.selectMaterial = {
          ...this.form.job.inputs[index].options[options.length - 1],
          fact: '',
          factUnit: '',
          inVolume: data.type === 'constructions',
          parentId: id,
          type: data.type
        };
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px !important;
}

.add-jobs {
  display: flex;
  flex-direction: column;


  .el-form-item {
    margin-bottom: 0px !important;
  }

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    width: 100%;
    justify-content: flex-start;
    min-height: 36px;
    padding: 8px 10px;
    display: flex;
    text-align: left;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      justify-content: center;
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.jobs-create-container {
  margin-top: -46px !important;
}

.sum-icon {
  font-weight: bold;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #fff;
  background: black;
  cursor: pointer;
  border-radius: 50%;
}

.disable-report {
  opacity: 0.6;
  pointer-events: none;
}

.add-jobs-values {
  display: flex;
}

.material-title {
  margin-top: 4px;
  display: flex;
  align-items: center;
}

.head-date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

@media screen and (max-width: 764px) {
  .history {
    flex-direction: column !important;
  }
}

.history {
  display: flex;
  align-items: center;

  span {
    font-size: 10px;
  }

  strong {
    color: #000;
    font-size: 18px;
  }

  .report-number {
    display: flex;
    flex-direction: column;

    strong {
      font-size: 16px;
    }
  }

  i {
    font-size: 26px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.disable-report {
  opacity: 0.6;
  pointer-events: none;
}


.el-icon-document-copy {
  font-size: 20px;
  cursor: pointer;
}

.fact-prof-name {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 4px;
  cursor: pointer;
  color: #000;

  i {
    margin-left: 6px;
  }
}

.el-icon-success {
  color: #2ecc71;
  font-size: 20px;
}

.report-file {
  display: flex;
  margin-top: 8px;
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
}


.links-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  align-items: center;

  a {
    color: #3676cb;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  i {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.8;
  }
}

.set-up-header-button {
  position: absolute;
  margin-top: -32px;
  font-size: 24px;
  display: flex;
  width: calc(100% - 200px);
  justify-content: center;
  margin-left: 100px;
  margin-right: 100px;
  right: 0;
  z-index: 99;

  .el-icon-set-up {
    margin-left: 232px;
    cursor: pointer;
  }
}


.plus-header-button {
  color: #3676cb;
  position: absolute;
  margin-top: -42px;
  display: flex;
  width: calc(100% - 240px);
  justify-content: center;
  display: flex;
  align-items: center;
  margin-right: 100px;
  right: 0;
  margin-left: 220px;

  z-index: 100;

  .plus-button {
    cursor: pointer;
    margin-right: 8px;
    font-size: 30px;
  }

  .el-icon-set-up {
    font-size: 24px;
    color: #0e1011;
    cursor: pointer;

  }

}

.back-button-left {
  position: absolute;
  font-size: 18px;
  margin-top: -36px;
  cursor: pointer;
}

.input-search {
  position: sticky;
  top: 75px;
  z-index: 11;
  margin-top: 4px;
  background: #fff;
}

</style>

<style lang="scss">
.add-jobs-dialog-workorder {
  .el-dialog__body {
    padding-top: 0px !important;
  }


  .dialog-footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding-top: 4px;
    width: calc(100% + 12px);
    padding-bottom: 12px;
    z-index: 11;
    @media screen and (max-width: 500px) {
      padding: 4px;
    }
  }

  .el-dialog__header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
  }

  .back-button-left {
    z-index: 10;
    position: sticky;
    top: 22px;
    display: flex;
  }

  .plus-header-button {
    z-index: 11;
    position: sticky;
    top: 10px;
    margin-top: -24px;
  }

  .set-up-header-button {
    z-index: 11;
    position: sticky;
    top: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddJobs.vue